let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2GwKS")).then(() => parcelRequire('cTtbu'));